/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRating interface.
 */
export function instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsStorePageRating(value) {
    return true;
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRatingFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRatingFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRatingFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'AverageRating': json['AverageRating'] == null ? undefined : json['AverageRating'],
        'ReviewCount': json['ReviewCount'] == null ? undefined : json['ReviewCount'],
    };
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRatingToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRatingToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRatingToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'AverageRating': value['AverageRating'],
        'ReviewCount': value['ReviewCount'],
    };
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRating.js.map